'use es6';

import hubspotMobileApp from 'bender-url!../../img/hubspotMobileApp.png';
import microsoftLogo from 'bender-url!../../img/ms-logo.png';
import googleLogo from 'bender-url!../../img/google-logo.png';
import chatSpotLogo from '!bender-url!../../img/chatspot-icon.png';
export default {
  googleLogo,
  hubspotMobileApp,
  microsoftLogo,
  chatSpotLogo
};